import { ModuleName } from "@/store/AppStore.types"
import { createContext } from "react"
import { UseMutateFunction, UseMutationResult, UseQueryResult } from "react-query"

export type TTabList = "add_notes" | "prev_notes" | "booking_notes" | ""

export type TPrevNoteList = {
  id: number
  notes_image: any
  images: any
  created_at: string
  notes: string // This is used in other modules
  Note?: string // This is used in add_note and Cleans module.
  user_name: string
  user?: {
    id: number
    first_name: string
    last_name: string
    email: string
  }
}

export type TNotesModule = {
  open: boolean
  onClose: Function
  moduleName?: ModuleName
  addNotes?: {
    notesCount: number | undefined
    onSubmit?: Function | undefined
    mutation?: UseMutationResult<unknown, unknown, any, unknown>
  }
  previousNotes?: {
    data: Array<TPrevNoteList>
    refetch?: UseQueryResult["refetch"]
  }
  bookingNotes?: {
    reservationId?: number | string
    eventType?: string
  }
}

export interface TBookingNotesRes {
  next_booking_details: NextBookingDetails
  current_booking_details: CurrentBookingDetails
}

export interface NextBookingDetails {
  notes: string
  arrivalDate: string
  hostawayReservationId: string
}

export interface CurrentBookingDetails {
  listingMapId: number
  arrivalDate: string
  hostNote: string
  guestNote: string
}

const NotesContext = createContext<TNotesModule>({
  open: false,
  onClose: () => {},
  addNotes: {
    notesCount: 0,
  },
  previousNotes: {
    data: [],
  },
  bookingNotes: {
    reservationId: 0,
    eventType: "",
  },
})

export { NotesContext }
